import { createAsyncThunk } from '@reduxjs/toolkit';
import { ProcosApi } from '../../../api/ProcosAPi';
import type { ICreateRuleRequest, IEffectivityRequest } from '../../../../types';
import type {
  IMarketAssociationRequest,
  IReadFeatures,
  IReadMarketAssociations,
  IReadMarkets,
} from '../../../../types/IRequestTypes';

//call the getWorkItems api and dispatch the response to the state
export const getWorkItems = createAsyncThunk('procos/getWorkItems', async () => {
  return await ProcosApi.getWorkItems();
});

//call the getMarkets api and dispatch the response to the state
export const getMarkets = createAsyncThunk('procos/getMarkets', async (action: IReadMarkets) => {
  return await ProcosApi.getMarkets(action);
});

//call the getMarketAssociations api and dispatch the response to the state
export const getMarketAssociations = createAsyncThunk(
  'procos/getMarketAssociation',
  async (action: IMarketAssociationRequest) => {
    const req: IReadMarketAssociations = {
      productCode: action.productCode,
      workItemId: action.workItemId,
      onlyMarketRules: action.onlyMarketRules,
    };
    return await ProcosApi.getMarketAssociations(req);
  }
);

export const getFeatures = createAsyncThunk('procos/getFeatures', async (action: IReadFeatures) => {
  return await ProcosApi.getFeatures(action);
});

//call create workitem api and dispatch the respose to the state
export const createWorkItem = createAsyncThunk('procos/createWorkItem', async (action: string) => {
  return await ProcosApi.createWorkItem(action);
});

//call create rule api and dispatch the respose to the state
export const createRules = createAsyncThunk(
  'procos/createRule',
  async (action: ICreateRuleRequest) => {
    return await ProcosApi.createRules(action);
  }
);

//call create effectivity api and dispatch the respose to the state
export const createEffectivity = createAsyncThunk(
  'procos/createEffectivity',
  async (action: IEffectivityRequest) => {
    return await ProcosApi.createEffectivity(action);
  }
);
